<template>
  <span @click.prevent.stop="deleteHistory" class="close"></span>
</template>
<script setup lang="ts">
import {NaviRequest} from "../../api/NaviRequest";
import {NaviClient} from "../../api/NaviClient";
import {Storage} from "../../localstorage/Storage";
import {ref} from "vue";

const props = defineProps({
  company: {
    type: Object,
    required: true
  }
});
const emit = defineEmits(['deleteCompany']);
const company = ref(props.company);

const deleteHistory = (e) => {
  //ログイン中
  if (globalThis.IS_USER_LOGIN) {
    NaviClient.browsingDelete(company.value.company_id).then((json) => {
      console.log(json);
    }).catch((error) => {
      console.log(error);
    });
  } else {
    Storage.deleteHistory(company.value.company_id);
  }
  console.log('deleteHistory');
  emit('deleteCompany',company);
};
</script>